module.exports = __webpack_public_path__ + "img/whel.3645ff31.png";